export const Loader = () => {
  return (
    <div className="absolute inset-0 z-20 flex items-center justify-center bg-white/40 backdrop-blur-md transition-all duration-300">
      {/* Frosty borders */}
      <div className="absolute left-0 right-0 top-0 h-[1px] bg-gradient-to-r from-transparent via-white/70 to-transparent opacity-80"></div>
      <div className="absolute bottom-0 left-0 right-0 h-[1px] bg-gradient-to-r from-transparent via-white/40 to-transparent opacity-60"></div>
      <div className="absolute bottom-[10%] left-0 top-[10%] w-[1px] bg-gradient-to-b from-transparent via-white/40 to-transparent opacity-60"></div>
      <div className="absolute bottom-[10%] right-0 top-[10%] w-[1px] bg-gradient-to-b from-transparent via-white/40 to-transparent opacity-60"></div>

      {/* Spinner with glassmorphism effect */}
      <div className="relative h-12 w-12 rounded-full bg-white/30 p-2 shadow-lg backdrop-blur-md">
        <div className="absolute inset-0 rounded-full border border-white/50"></div>
        <div className="absolute inset-[2px] rounded-full border border-white/20"></div>
        <div className="border-t-accent-400 border-r-accent-400/70 h-full w-full animate-spin rounded-full border-2 border-transparent"></div>

        {/* Light refraction effect */}
        <div className="bg-gradient-radial pointer-events-none absolute -right-[150%] -top-[150%] h-[300%] w-[300%] rotate-12 from-white/30 to-transparent opacity-30"></div>
      </div>
    </div>
  )
}
